<template>
  <v-container fluid>
    <v-row>
      <v-col cols="8" md="10">
        <v-card>
          <Toolbar />
          <router-view />
          <v-container>{{
            t("campaign.generic.campaign_ident", { ident: campaignIdent })
          }}</v-container>
        </v-card>
      </v-col>
      <v-col cols="4" md="2">
        <sidebar-nav :menu="menu" type="coupon" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCampaignStore } from '@/stores/campaign'
import Toolbar from '@/components/campaign/snippets/Toolbar.vue'
import SidebarNav from '@/components/campaign/snippets/SidebarNav.vue'

const props = defineProps({
  campaignIdent: String
})

const { t } = useI18n()
const campaignStore = useCampaignStore()

const menu = ref([
  {
    label: 'benefit',
    to: 'coupon-benefit',
  },
  {
    label: 'description',
    to: 'coupon-content',
  },
  {
    label: 'image',
    to: 'coupon-image',
  },
  {
    label: 'handling',
    to: 'coupon-handling',
  },
  {
    label: 'requireddata',
    to: 'coupon-requireddata',
  },
  {
    label: 'review',
    to: 'coupon-review',
  },
])

const current = computed(() => campaignStore.currentIdent)

watch(() => props.campaignIdent, async (newVal) => {
  await campaignStore.setCurrent(newVal)
})

onMounted(async () => {
  if (!current.value || current.value != props.campaignIdent) {
    await campaignStore.setCurrent(props.campaignIdent)
  }
})
</script>
